import MenuIcon from '@mui/icons-material/Menu';
import {Box, ButtonBase, Grid} from '@mui/material';
import {UserMenuItem} from '@/shared/components/layout/UserMenu';
import UserMenu from '@/shared/components/layout/UserMenu';
import FlexBox from '@/shared/components/ui/FlexBox';
import useLoggedUserContext from '@/shared/contexts/UserContext/useUserContext';
import Notifications from './components/Notifications';

export default function Header({
  id,
  onClickHamburger,
  extraUserMenuItems
}: {
  id: string;
  onClickHamburger: () => void;
  extraUserMenuItems?: UserMenuItem[];
}) {
  const {user} = useLoggedUserContext();
  return (
    <Box
      sx={(theme) => ({
        position: {
          xs: 'fixed',
          lg: 'static'
        },
        left: {
          xs: 0,
          left: 'auto'
        },
        top: {
          xs: 0,
          left: 'auto'
        },
        width: '100%',
        py: {
          xs: 1,
          lg: 0
        },
        minHeight: {
          xs: theme.layout.headerHeight.mobile,
          lg: theme.layout.headerHeight.desktop
        },
        px: theme.layout.containerPaddingHorizontal,
        mb: {
          xs: 0,
          lg: 2
        },
        zIndex: 'appBar',
        backgroundColor: {
          xs: 'secondary.light',
          lg: 'transparent'
        },
        overflow: 'hidden'
      })}
      id={id}
    >
      <Grid container alignItems="center">
        <Grid
          sx={{
            display: {
              xs: 'block',
              lg: 'none'
            }
          }}
          size={{xs: 1, lg: 0}}
        >
          <ButtonBase onClick={onClickHamburger} data-testid="hamburgerMenuBtn">
            <MenuIcon />
          </ButtonBase>
        </Grid>
        <Grid
          size={{
            xs: 11,
            lg: 12
          }}
        >
          <FlexBox justifyContent="flex-end">
            <Notifications />
            <UserMenu user={user} extraUserMenuItems={extraUserMenuItems} />
          </FlexBox>
        </Grid>
      </Grid>
    </Box>
  );
}
